import React from "react";
import { ellipsisStyle } from "@msys/ui";
import { Attachment as AttachmentIcon } from "@mui/icons-material";
import { IconButton, Link, Stack, Typography } from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { Attachment } from "./helpers.js";

interface Props {
  attachment: Attachment;
  onRemove: (attachment: Attachment) => Promise<void>;
  icon?: JSX.Element;
  disabled?: boolean;
}

export const AttachmentFileRow = ({
  attachment,
  onRemove,
  icon = <AttachmentIcon fontSize="small" />,
  disabled = false,
}: Props) => (
  <Stack
    direction="row"
    spacing={1}
    key={attachment.id}
    sx={{
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
    }}
  >
    <Stack
      direction="row"
      spacing={1}
      style={ellipsisStyle}
      sx={{
        alignItems: "center",
      }}
    >
      {icon}
      <Typography variant="body2" style={ellipsisStyle}>
        <Link href={attachment.url} target="_blank" rel="nofollow noreferrer">
          {attachment.title}
        </Link>
      </Typography>
    </Stack>
    <IconButton
      disabled={disabled}
      color="secondary"
      aria-label="Delete attachment"
      onClick={() => onRemove(attachment)}
      size="small"
    >
      <DeleteIcon />
    </IconButton>
  </Stack>
);
